import styled from 'styled-components';

export const Divider = styled.hr`
  border-top: 1px solid ${({ theme }) => theme.colors.white.three};
  margin: 24px 0px;
`;
